import layout from '@/components/common/layout';
import resumeList from '../views/resume/list';
import resumeMy from '../views/resume/list-my';
import resumeCreate from '../views/resume/create';
import resumeManagerList from '../views/resume/list-manager';
import resumeVisitList from '../views/resume/list-visit';

export default [
    {
        path: '/resume',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "简历列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'resume_list',// 子选项
                    }
                },
                component: resumeList,
            },
            {
                path: 'list-my',
                meta: {
                    metaInfo: {
                        title: "我的简历",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'resume_my',// 子选项
                    }
                },
                component: resumeMy,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增简历",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'resume_list',// 子选项
                    }
                },
                component: resumeCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑简历",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'resume_list',// 子选项
                    }
                },
                component: resumeCreate,
            },
            {
                path: 'manager',
                meta: {
                    metaInfo: {
                        title: "分配记录",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'resume_list',// 子选项
                    }
                },
                component: resumeManagerList,
            },
            {
                path: 'visit',
                meta: {
                    metaInfo: {
                        title: "拜访记录",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'resume_list',// 子选项
                    }
                },
                component: resumeVisitList,
            },
        ]
    },
];
